'use strict';
import { module } from '../app';
import * as _ from 'lodash';

module
  .factory('linkStudiesViewModel', [
    'Worklist', 'modalService',
    function (Worklist,
              modalService) {
      function linkStudiesViewModel(worklist) {

        let self = this;

        self.isShowPrimaryValidation = false;
        self.worklist = worklist;

        self.sides = [ {
          Key: 'L',
          Value: 'Left'
        }, {
          Key: 'R',
          Value: 'Right'
        }, {
          Key: 'B',
          Value: 'Both'
        } ];

        self.getSide = function (sideKey) {
          let side = self.sides.find(x => x.Key === sideKey);

          let sideValue = side && side.Value;
          return sideValue ? ` - ${sideValue}` : '';
        };

        self.saveLinked = function (modal) {
          let primary = _.find(self.studies, {isPrimary: true});
          let hasLinked = !!_.find(self.studies, {isLinked: true});
          if (hasLinked && !primary) {
            self.isShowPrimaryValidation = true;
          } else {
            _.each(self.studies, function (x) {
              x.LinkedTo = null;
              if (x.isLinked) {
                x.LinkedTo = primary.SDate;
              }
            });
            Worklist.saveLinkedStudies(self.worklist.Id, self.studies).then(function () {
              modal.remove().then(function () {});
            });
          }
        };

        self.togglePrimary = function (study) {
          study.isPrimary = !study.isPrimary;
          if (study.isPrimary) {
            study.isLinked = false;
          }
          if (!study.isPrimary) {
            _.each(self.studies, function (x) {
              x.isPrimary = false;
              x.isLinked = false;
            });
          } else {
            _.each(self.studies, function (x) {
              if (x.SDate.localeCompare(study.SDate) != 0) {
                x.isPrimary = false;
                x.isLinked = true;
              }
            });
          }
          self.isShowPrimaryValidation = false;
        };

        self.toggleLinked = function (study) {
          study.isLinked = !study.isLinked;
          if (study.isLinked) {
            study.isPrimary = false;
            if (self.studies.length === 2) {
              _.each(self.studies, function (item) {
                if (item !== study) {
                  item.isPrimary = true;
                  item.isLinked = false;
                }
              });
              return;
            }
          }

          if (!_.find(self.studies, {isPrimary: true})) {
            let notDefined = _.filter(self.studies, function (x) {
              return !x.isLinked;
            });
            if (notDefined && notDefined.length == 1) {
              notDefined[ 0 ].isPrimary = true;
            } else if (_.every(self.studies, {isLinked: true})) {
              modalService.showAlert('Cannot set all studies as linked. There must be a primary study', function () {
                if (study.isLinked) {
                  study.isPrimary = true;
                  study.isLinked = false;
                }
              }, 'link-studies-no-primary-error');
            }
          }

          if (_.find(self.studies, {isPrimary: true}) && !_.find(self.studies, {isLinked: true})) {
            let primary = _.find(self.studies, {isPrimary: true});
            self.togglePrimary(primary);
          }
        };
        
        self.processSingleLinkedStudy = (study) => {
          if (study.LinkedTo) {
            study.isLinked = true;
            let primary = _.find(self.studies, { SDate: study.LinkedTo });
            if (primary) {
              primary.isPrimary = true;
            }
          }
        }

        self.initializeLinkedStudies = async () => {
          let resp = await Worklist.getSameDayStudies(worklist.Id);
          
          self.studies = resp.data;

          _.each(self.studies, self.processSingleLinkedStudy);
        };
      }

      return linkStudiesViewModel;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/linkStudies.js